const dayjs = require('dayjs');
const { isArray, first, get } = require('lodash');

const cookies = {
    ots: {
        cookieName: 'BM-ots-tracking',
        duration: '999 days',
        queryParam: 'ots',
        defaultValue: 'direct',
        overwritable: false,
        ignoreIfAdmin: true,
        setTimestamp: true,
        transform: (urlValue, req = {}) => {
            let headerReferrer = (req.headers && req.headers.referer || '').replace(/^(https?):\/\//, '');
            console.log({ headerReferrer })
            if (headerReferrer) headerReferrer = `direct-${headerReferrer}`;
            return urlValue || headerReferrer;
        },
    },
    cid: {
        cookieName: 'BM-cid-tracking',
        duration: '60 days',
        queryParam: 'cid',
        overwritable: true,
        ignoreIfAdmin: true,
        setTimestamp: false,
    },
    dtl: {
        cookieName: 'BM-dtl-tracking',
        duration: '60 days',
        queryParam: 'dtl',
        overwritable: true,
        ignoreIfAdmin: true,
        setTimestamp: true,
    },
    ppp: {
        cookieName: 'BM-ppp-tracking',
        duration: '60 days',
        queryParam: 'ppp',
        overwritable: true,
        ignoreIfAdmin: true,
        setTimestamp: true,
    },
    rtg: {
        cookieName: 'BM-rtg-tracking',
        duration: '60 days',
        queryParam: 'rtg',
        overwritable: true,
        ignoreIfAdmin: true,
        setTimestamp: true,
    },
    ref: {
        cookieName: 'BM-ref-tracking',
        duration: '60 days',
        queryParam: 'ref',
        overwritable: true,
        ignoreIfAdmin: true,
        setTimestamp: true,
    },
    quoteId: {
        cookieName: 'quoteId',
        duration: '1 hour',
        queryParam: 'quote_id',
        overwritable: true,
    },
    quoteToken: {
        cookieName: 'quoteToken',
        duration: '1 hour',
        queryParam: 'quote_token',
        overwritable: true,
    },
    promo: {
        cookieName: 'BM-promo',
        duration: '3 days',
        queryParam: 'promo',
        overwritable: true,
        ignoreIfAdmin: true,
        transform: (queryValue = '') => queryValue.toUpperCase().replace(/\s+/g, ''),
    },
    'cookie-consented': {
        setLocalsOnly: true,
    },
    qqid: {
        queryParam: 'qqid',
        setLocalsOnly: true,
    },
    sid: {
        queryParam: 'sid',
        setLocalsOnly: true,
    },
    reg: {
        queryParam: 'reg',
        setLocalsOnly: true,
    },
    gaShort: {
        cookieName: 'gaVisitorTypeShort',
        duration: '30 mins',
        defaultValue: 'prospect',
        overwritable: true,
        ignoreIfAdmin: true,
        setTimestamp: false,
        transform: (urlValue, req = {}) => (get(req.cookies, 'gaVisitorTypeShort') || get(req.cookies, 'gaVisitorTypeLong')),
    },
    gaLong: {
        cookieName: 'gaVisitorTypeLong',
        duration: '2 years',
        defaultValue: 'prospect',
        overwritable: false,
        ignoreIfAdmin: true,
        setTimestamp: false,
    },
};

function getValue(req, queryParam, transform, defaultValue) {
    let urlValue = isArray(req.query[queryParam]) ? first(req.query[queryParam]) : req.query[queryParam];

    if (transform) urlValue = transform(urlValue, req);

    return urlValue || defaultValue;
}

module.exports = (req) => {
    const cookieMonster = {}
    const clearCookies = []
    const setCookies = []
    Object.keys(cookies).forEach((key) => {
        const {
            cookieName,
            duration,
            queryParam,
            transform,
            overwritable,
            defaultValue,
            setLocalsOnly,
            ignoreIfAdmin,
            setTimestamp,
        } = cookies[key];

        const isAdmin = req.cookies['BM-admin'];
        if (isAdmin && ignoreIfAdmin) {
            if (req.cookies[cookieName]) clearCookies.push(cookieName)
            return true;
        }

        const isComparison = (req.query.dtl || '').includes('comparison') || (req.cookies[cookies.dtl.cookieName] || '').includes('comparison');

        if (key === 'promo' && isComparison) {
            if (req.cookies[cookieName]) clearCookies.push(cookieName)
            return true;
        }

        if (setLocalsOnly && !queryParam) {
            cookieMonster[key] = req.cookies[key];
            return true;
        }

        if (setLocalsOnly && queryParam) {
            cookieMonster[key] = req.query[queryParam];
            return true;
        }

        let value = getValue(req, queryParam, transform, defaultValue);

        if (setTimestamp && value) {
            const timestamp = dayjs().unix();

            const unixTimestampAfterColon = /(^.*):(\d{10})/;
            const matches = value.match(unixTimestampAfterColon);


            if (!matches) {
                value += `:${timestamp}`;
            } else {
                value.replace(unixTimestampAfterColon, timestamp);
            }
        }

        if ((!req.cookies[cookieName] && value) || (overwritable && value)) {
            setCookies.push({ cookieName, value, duration })
        }

        if (req.cookies[cookieName] && !overwritable) {
            cookieMonster[key] = req.cookies[cookieName];
        } else if (value) {
            cookieMonster[key] = value;
        } else if (req.cookies[cookieName]) {
            cookieMonster[key] = req.cookies[cookieName];
        }
    });
    return {
        cookieMonster,
        clearCookies,
        setCookies
    }
}
